module.exports = __webpack_public_path__ + "img/sole1.87cbee39.png";